/* eslint-disable no-empty-pattern */
/* eslint-disable array-bracket-newline */
/**
 * Implements a page header bar
 */
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Image from '../../../atoms/Image';
import Text from '../../../atoms/Text';
import MobileNavItem from './NavItem';
import { actionShowModal } from '../../../actions/modal';
import { ModalTypes } from '../../../reducers/modal';
import { useWallet } from '../../../wallet/walletContext';

import watchlist from '../../../assets/images/watchlist_down.svg';
import swap from '../../../assets/images/swap_grey.svg';
import logo from '../../../assets/images/kattana_logo.svg';
import search from '../../../assets/images/search_grey.svg';
import notification from '../../../assets/images/notification_grey.svg';
import list from '../../../assets/images/list.svg';
import walletAdd from '../../../assets/images/wallet_add.svg';
import wallet from '../../../assets/images/wallet_grey.svg';

import './styles.scss';

interface IHeaderProps {
  onToggleSidebar: () => void;
  onToggleSearch: () => void;
  onToggleNews: () => void;
  onToggleTrading: () => void;
  onToggleWatchlist: () => void;
}

const HeaderMobile = ({
  onToggleSidebar,
  onToggleSearch,
  onToggleNews,
  onToggleTrading,
  onToggleWatchlist,
}: IHeaderProps) => {
  const dispatch = useDispatch();
  const { isConnected } = useWallet();

  return (
    <div className='global_header_mobile'>
      <div className='global_header_mobile__left_menu'>
        <div className='global_header_mobile__left_menu__logo_box'>
          <Link to='/'>
            <Image size='m' src={logo} />
          </Link>
        </div>
        <div
          className='global_header_mobile__left_menu__search'
          onClick={onToggleSearch}
        >
          <div className='global_header_mobile__left_menu__search__icon'>
            <Image size='m' src={search} />
          </div>
          <div className='global_header_mobile__left_menu__search__placeholder'>
            <Text
              size={12}
              className='global_header_mobile__left_menu__search__placeholder__text'
            >
              Search...
            </Text>
          </div>
        </div>
      </div>
      <div className='global_header_mobile__right_menu'>
        <MobileNavItem
          icon={watchlist}
          alt='watchlist'
          onClick={onToggleWatchlist}
        />
        <MobileNavItem icon={swap} alt='trading' onClick={onToggleTrading} />
        <MobileNavItem
          icon={isConnected ? wallet : walletAdd}
          alt='connect wallet'
          onClick={() => dispatch(actionShowModal(ModalTypes.connect, {}))}
        />
        <MobileNavItem icon={notification} alt='news' onClick={onToggleNews} />
        <MobileNavItem icon={list} alt='menu' onClick={onToggleSidebar} />
      </div>
    </div>
  );
};

export default HeaderMobile;
